/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('RelacionAdminController', RelacionAdminController);

    /* @ngInject */
    function RelacionAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                     ModalService, Relacion, $translate, Principal) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });


        vm.item = Relacion;

        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole =  Principal.identity().$$state.value.role;

        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            revisado: undefined,
            repasado: undefined,
            idAutor: $stateParams.idAutor,
            nombreAutor: $stateParams.nombreAutor,
            idLugar: $stateParams.idLugar,
            nombreLugar: $stateParams.nombreLugar
        };

        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {titulo: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Relacion.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.relacion.delete.name',
                                body: 'admin.relacion.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        }

    }

})(angular);
